module.exports = "/_next/static/images/BusinessPlan-sm-ef91e92a862aa505572702947dd7c9a2.webp";